import { colors } from '@src/styles';

/** Formats a success rate as a percentage string, e.g. "97.3%". Returns "—" when total is 0. */
export const pct = (ok: number, total: number): string => (total ? `${((ok / total) * 100).toFixed(1)}%` : '—');

/** Formats a duration in milliseconds as "1.2s" (>=1000ms) or "850ms". */
export const fmtDuration = (ms: number): string => (ms >= 1000 ? `${(ms / 1000).toFixed(1)}s` : `${Math.round(ms)}ms`);

export const titleFontFamily = "'Inter Tight', 'Inter', sans-serif";
export const monoFontFamily = "'JetBrains Mono', monospace";

/** Shared card container style used across Runs analytics views. */
export const card = {
  p: 2.25,
  borderRadius: '14px',
  border: `1px solid ${colors.brand.line}`,
  backgroundColor: colors.brand.surface,
  backgroundImage: 'none',
  color: colors.primary.white,
} as const;

export const cardTitleSX = {
  fontFamily: titleFontFamily,
  fontSize: '15px',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  color: colors.primary.white,
} as const;

export const monoLabelSX = {
  fontFamily: monoFontFamily,
  fontSize: '10px',
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: colors.brand.textMuted,
} as const;

export const skeletonSX = { backgroundColor: 'rgba(255, 255, 255, 0.06)' } as const;

export const paginationSX = {
  '& .MuiPaginationItem-root': {
    minWidth: 28,
    height: 28,
    borderRadius: '7px',
    fontFamily: monoFontFamily,
    fontSize: '12px',
    color: colors.brand.textSecondary,
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)', color: colors.primary.white },
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: 'rgba(255, 160, 21, 0.14)',
    color: colors.primary.yellow,
    border: '1px solid rgba(255, 160, 21, 0.45)',
    '&:hover': { backgroundColor: 'rgba(255, 160, 21, 0.2)' },
  },
  '& .MuiPaginationItem-icon': { color: 'inherit' },
} as const;

export const footnoteSX = {
  fontFamily: monoFontFamily,
  fontSize: '11px',
  color: colors.brand.textMuted,
} as const;

export const getLogsEmptyMessage = (contextSearch: string): string =>
  contextSearch ? `Nenhuma execução com “${contextSearch}” no contexto.` : 'Nenhuma execução no período.';
